import {
  EyeIcon,
  TrashIcon,
  CheckCircleIcon,
  XCircleIcon,
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
  MegaphoneIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { adminDeletePost, getAllPostsAdmin, togglePostActive, togglePostSponsored, togglePostTrending } from "../../slices/2-post/thunk";
import PostDetailsModal from "../../component/SettingsPostPage/PostDetailsModal";
import ConfirmDeleteModal from "../../component/sharedComponents/ConfirmDeleteModal";
import Pagination from "../../component/sharedComponents/Pagination";
import avatar from "../../assets/images/Avatar.avif"
import { setFilter } from "../../slices/searchSlice";
import SectionLoader from "../../component/sharedComponents/Loading/SectionLoader";

const SettingsPostPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const { posts, pagination, loading } = useSelector((state) => state.posts)
  const { query, filter } = useSelector((state) => state.search);

  const [selectedPost, setSelectedPost] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletePost, setDeletePost] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getAllPostsAdmin({ limit: 10, page: 1 }))
  }, [dispatch])


  useEffect(() => {
    const params = {
      page: 1,
      limit: 10,
      ...(query && { search: query }),
    };

    switch (filter) {
      case "admin":
      case "company":
        params.type = filter;
        break;

      case "trending":
        params.isTrending = 1;
        break;

      case "sponsored":
        params.isSponsored = 1;
        break;

      default:
        break;
    }
    // console.log(params)
    dispatch(getAllPostsAdmin(params));

  }, [query, filter, dispatch]);




  const openDeleteModal = (post) => {
    setDeletePost(post);
    setIsDeleteModalOpen(true);
  };


  const closeDeleteModal = () => {
    setDeletePost(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = (postId) => {
    dispatch(adminDeletePost(postId));
    closeDeleteModal();
  };
  const openModal = (post) => {
    setSelectedPost(post);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedPost(null);
    setIsModalOpen(false);
  };



  const handleToggle = (postId) => {
    dispatch(togglePostActive(postId));
  }
  const handleTrendingToggle = (postId) => {
    dispatch(togglePostTrending(postId));
  }
  const handleSponsoredToggle = (postId) => {
    dispatch(togglePostSponsored(postId));
  }


  const handlePageChange = (page) => {
    dispatch(getAllPostsAdmin({ page, limit: 10 }));
  };

  // const filteredPosts = posts?.filter(post =>
  //   post?.text?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //   post?.User?.fullName?.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  // console.log(posts)
  return (
    <div className="w-full space-y-4 text-gray-900 dark:text-gray-100">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-xl font-semibold text-black dark:text-white">
          {t("posts.title")}
        </h1>
        <select
          onChange={(e) => dispatch(setFilter(e.target.value))}
          className="px-4 py-2 text-sm border rounded-lg dark:text-text-muted-dark text-text-muted-light dark:bg-bg-dark-secondary bg-bg-light-secondary dark:border-border-dark border-border-light focus:outline-none"
        >
          <option value="">{t("filterPost.all")}</option>

          <option value="admin">{t("filterPost.admin")}</option>
          <option value="company">{t("filterPost.company")}</option>

          <option value="trending">{t("filterPost.trending")}</option>
          <option value="sponsored">{t("filterPost.sponsored")}</option>
        </select>

        {/* <select
          onChange={(e) => dispatch(setFilter(e.target.value))}
          className="px-4 py-2 text-sm border rounded-lg dark:text-text-muted-dark text-text-muted-light dark:bg-bg-dark-secondary bg-bg-light-secondary dark:border-border-dark border-border-light focus:outline-none">
          <option value="">{t("filterPost.all")}</option>
          <option value="default">{t("filterPost.default")}</option>
          <option value="ads">{t("filterPost.ads")}</option>
          <option value="trending">{t("filterPost.trending")}</option>
          <option value="company">{t("filterPost.company")}</option>
        </select> */}
      </div>

      {/* ===== Table Wrapper ===== */}
      <div className="relative  overflow-x-auto no-scrollbar w-[90vw] md:w-full">
        {/* IMPORTANT: min-width */}
        <div className="">

          {loading ? <SectionLoader /> : posts?.length === 0 ? <p className="w-full text-center">{t("NotFound")}</p> :
            <>
              {/* Wrapper for horizontal scroll */}
              <div className="w-full overflow-x-auto">
                <table className="min-w-full text-sm text-left border table-auto rounded-xl dark:border-border-dark border-border-light">
                  <thead className="text-xs uppercase dark:bg-bg-dark-secondary bg-bg-light-secondary">
                    <tr className="text-center">
                      <th className="px-4 py-3">{t("posts.ID")}</th>
                      <th className="px-4 py-3">{t("posts.profile")}</th>
                      <th className="px-4 py-3">{t("posts.fullName")}</th>
                      <th className="max-w-xs px-4 py-3">{t("posts.post")}</th>
                      <th className="px-4 py-3">{t("posts.date")}</th>
                      <th className="px-4 py-3">{t("posts.type")}</th>
                      <th className="px-4 py-3 text-center">{t("posts.actions")}</th>
                    </tr>
                  </thead>
                  <tbody className="py-2 dark:bg-bg-dark-secondary bg-bg-light-secondary">
                    {posts?.map((post, index) => (
                      <tr key={post?.id} className="text-center duration-300 hover:bg-bg-light-primary dark:hover:bg-bg-dark-primary">
                        <td className="px-2 py-3">{index + 1}</td>
                        <td className="flex justify-center px-2">
                          <img src={post?.isCompany ? post?.Company?.logo : post?.User?.avatar || avatar} className="w-8 h-8 rounded-full" alt={(post?.type === "ads" || post?.type === "company") ? post?.User?.Companies?.[0]?.name_EN : post?.User?.fullName} />
                        </td>
                        <td className="max-w-xs px-2 truncate">{post?.isCompany ? post?.Company?.name_EN : post?.User?.fullName}</td>
                        <td className="max-w-xs px-2 truncate">{post?.text}</td>
                        <td className="px-2">{new Date(post?.createdAt).toLocaleDateString()}</td>
                        <td className="px-2">
                          {post?.isCompany ? (
                            <span className="px-3 py-1 text-xs dark:text-[#970e80] text-[#1a0017] dark:bg-[#c509bf1a] bg-[#52036260] rounded-xl">
                              {t("postType.company")}
                            </span>
                          ) : (
                            <span className="px-3 py-1 text-xs dark:text-[#BBFF00] text-[#3f5600] dark:bg-[#BBFF001A] bg-[#bbff00f7] rounded-xl">
                              {t("postType.admin")}
                            </span>
                          )}
                        </td>
                        <td className="px-2">
                          <div className="flex items-center justify-center gap-3">
                            <button
                              onClick={() => openModal(post)}
                              title={t("actions.view")}
                            >
                              <EyeIcon className="w-5 h-5 text-yellow-400" />
                            </button>
                            <button
                              onClick={() => handleToggle(post.id)}
                              title={post?.isActive ? t("actions.deactivate") : t("actions.activate")}
                            >
                              {post?.isActive ? (
                                <CheckCircleIcon className="w-5 h-5 text-green-400" />
                              ) : (
                                <XCircleIcon className="w-5 h-5 text-red-500" />
                              )}
                            </button>
                            {/* {post?.url && */}
                            <button
                              onClick={() => handleTrendingToggle(post.id)}
                              title={
                                post?.isTrending
                                  ? t("actions.removeTrending")
                                  : t("actions.makeTrending")
                              }
                            >
                              {post?.isTrending ? (
                                <ArrowTrendingUpIcon className="w-5 h-5 text-green-400" />
                              ) : (
                                <ArrowTrendingDownIcon className="w-5 h-5 text-red-500" />
                              )}
                            </button>
                            {/* } */}
                            {post?.url ?
                              <button
                                onClick={() => handleSponsoredToggle(post.id)}
                                title={
                                  post?.isSponsored
                                    ? t("actions.removeSponsored")
                                    : t("actions.makeSponsored")
                                }
                              >
                                <MegaphoneIcon
                                  className={`w-5 h-5 ${post?.isSponsored ? "text-green-400" : "text-red-500"
                                    }`}
                                />
                              </button>
                              :
                              <div className="w-5 h-5">
                              </div>
                            }
                            <button onClick={() => openDeleteModal(post)}>
                              <TrashIcon className="w-5 h-5 text-red-500" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>


              {pagination && posts?.length > 0 && (
                <Pagination
                  pagination={pagination}
                  onPageChange={(page) => handlePageChange(page)}
                />
              )}
            </>
          }
        </div>
        {selectedPost && (
          <PostDetailsModal isOpen={isModalOpen} onClose={closeModal} post={selectedPost} />
        )}
        {deletePost && (
          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onConfirm={confirmDelete}
            post={deletePost}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsPostPage;
